import { createActionCreator } from '../../../includes/enhanced-reducer';

export interface ISetSearchFieldTextPayload {
    newSearchTerm: string;
}

const SET_SEARCH_FIELD_TEXT = 'SET_SEARCH_FIELD_TEXT';

export const setSearchFieldText = createActionCreator<ISetSearchFieldTextPayload>(SET_SEARCH_FIELD_TEXT);
